export default "#FFFFFF";

export const whiteShades = {
  z400: "#FFFFFF",
  z500: "#FFFFFF",
  z600: "#FFFFFF",
  z700: "#FFFFFF"
};
